module.exports = __webpack_public_path__ + "static/media/customersGreenActive.4b6ecb45.png";